import { OrderAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Observable } from 'rxjs';
import { InvoicePdfOptions } from 'app/modules/components/sales/invoice-list/Print/invoice-pdf-options.interface';
import { DocumentTypeEnum } from 'app/common/enums/document-types.enum';
import { InvoiceService } from 'app/modules/components/sales/invoice-list/Print/pdf-generator.service';

@Component({
  selector: 'app-reprint-button',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, MatButtonModule, MatMenuModule],
  template: `
    <button
      mat-menu-item
      (click)="reprint()"
      matTooltip="Reimprimir"
    >
      <mat-icon>print</mat-icon>
      <span>{{ label }}</span>
    </button>
  `,
})
export class ReprintButtonComponent {
  @Input() label = '';
  @Input() element!: OrderAttributes;
  @Input() typeDocument!: DocumentTypeEnum;

  constructor(private snackBar: MatSnackBar, private invoiceService: InvoiceService) {}

  reprint(): void {
    if (!this.element?._id) {
      this.snackBar.open('No se encontró el ID del documento', 'Cerrar', { duration: 3000 });
      return;
    }

    const id = this.element._id.toString();
    const options: InvoicePdfOptions = {
      format: 'letter',
      landscape: false,
      scale: 1,
      printBackground: true,
      marginTop: '10mm',
      marginBottom: '10mm',
    };

    this.invoiceService.downloadDocument(id, options, this.typeDocument).subscribe({
      next: () => {
        this.snackBar.open(`${this.label} descargado correctamente`, 'Cerrar', { duration: 3000 });
      },
      error: (error) => {
        this.snackBar.open(error.message || `Error al imprimir ${this.label}`, 'Cerrar', { duration: 5000 });
      },
    });
  }
}
